import useApi from 'common/hooks/useApi';
import useTypedSelector from 'common/hooks/useTypedSelector';
import { ActionCompleteResponse } from 'common/types/ApiResponse';
import React from 'react';
import { AccountSecurityForm } from './AccountSecurityForm';
import AccountSecurityPresenter from './AccountSecurityPresenter';

function AccountSecurityContainer() {
  const { email } = useTypedSelector((state) => state.auth);
  const [
    { data, loading: submitting },
    updatePassword,
  ] = useApi<ActionCompleteResponse>({
    url: '/profile/updatePassword',
    method: 'PUT',
  });

  const handleSubmit = async (values: AccountSecurityForm) => {
    await updatePassword(values);
  };

  return (
    <>
      <AccountSecurityPresenter
        email={email}
        response={data}
        onSubmit={handleSubmit}
        submitting={submitting}
      />
    </>
  );
}

export default AccountSecurityContainer;
